module.exports = __webpack_public_path__ + "static/media/form_delete.50eb56f5.svg";